import React, { useState, useEffect } from 'react';
import { TeamsDB } from '../db/TeamsDB';
import { Link } from 'react-router-dom';

import "./Rosters.css"

function Rosters() {
  const [teams, setTeams] = useState([])
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
  
    TeamsDB.getFromPrimeraFEB(true).then((teamsData) => {
      if (teamsData) {
        setTeams(teamsData);
      } else {
        setErrorMsg('No se han encontrado equipos en la Primera FEB');
      }
    }).catch((error) => {
      setErrorMsg(error.message || 'Ha ocurrido un error al cargar los equipos');
    });

  }, []); 
  
  



  const showTeams= () => {
    const teamsFiltered = teams.filter(team => team.otherCategory === undefined || !team.otherCategory)
    if (teamsFiltered.length > 0) {
      return teamsFiltered.map((team) => 
        <Link to="/team" state={{ team: team.id }} key={team.id}>
          <div className="logo-team">
            <img height="80em" src={team.url_logo} alt={team.url_logo}></img>
          </div></Link>)
    } else {
      return <></>
    }
  }



  return (
    <div className="container-rosters">
      <h2>Plantillas Primera FEB 2026/2027</h2>
      {showTeams()}
      {errorMsg}
    </div>
  )
}

export default Rosters